export default "__VITE_ASSET__DwtckN8k__"